// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import './style/app.scss';
import './polyfill/array.polyfill';
import './polyfill/promise.polyfill';

Vue.config.productionTip = false;
import {MessageBox} from 'element-ui';

Vue.prototype.$alert = MessageBox.alert;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
});

if (process.env.NODE_LOG === 0) {
  const consoleKey = Object.keys(console);
  const logs = {};
  consoleKey.forEach(key => {
    logs[key] = console[key];
    console[key] = function () {
    };
  });
  window.__openConsoleLog = function () {
    consoleKey.forEach(key => {
      console[key] = logs[key]
    });
  };
}



// WEBPACK FOOTER //
// ./src/main.js